import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-20 sm:py-28" data-id="element-62" data-mp="1hbgsk7h7rn14">
      <div className="mx-auto max-w-3xl" data-id="element-63" data-mp="1cf9nsi0k0hkr">
        <h2 className="text-center font-serif text-4xl font-semibold leading-tight text-espresso sm:text-5xl" data-id="element-64" data-mp="1ccdn4lxbnesm">
          Everything You Need to Know
        </h2>
        <div className="mt-12 space-y-3" data-id="element-65" data-mp="25474wht148bx">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-champagne bg-cream-light" data-id="element-66" data-mp="205vqdtrsh9nd" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-raspberry-soft" data-id="element-67" data-mp="oqgvcvj54ruw">
                  <span className="text-base font-semibold text-espresso" data-id="element-68" data-mp="1aq2apqecqe2b">
                    {faq.question}
                  </span>
                  <ChevronDownIcon size={20} className={`shrink-0 text-champagne-deep transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-69" data-mp="1fnccm5ixgi71" />
                </button>
                <AnimatePresence initial={false} data-id="element-70" data-mp="rz2ubdkxackn">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-71" data-mp="rx85vpag02bt">
                      <p className="border-t border-champagne px-6 py-5 text-sm leading-6 text-cocoa" data-id="element-72" data-mp="2pmn2hpx3pjwz">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}